<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <ifc-datepicker
      [fc]="form.get('transactionDateFrom')"
      baseFilterItem
      [label]="'Transaction date from'"
      [max]="form.get('transactionDateTo').value || today"
    ></ifc-datepicker>
    <ifc-datepicker
      [fc]="form.get('transactionDateTo')"
      baseFilterItem
      [label]="'Transaction date to'"
      [min]="form.get('transactionDateFrom').value || null"
    ></ifc-datepicker>

    <ifc-datepicker
      [fc]="form.get('postedDateFrom')"
      baseFilterItem
      [label]="'Transaction posted date from'"
      [max]="form.get('postedDateTo').value || today"
    ></ifc-datepicker>
    <ifc-datepicker
      [fc]="form.get('postedDateTo')"
      baseFilterItem
      [label]="'Transaction posted date to'"
      [min]="form.get('postedDateFrom').value || null"
    ></ifc-datepicker>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Amount from</mat-label>
      <input
        matInput
        formControlName="fromAmount"
        type="text"
        placeholder="Amount from"
        currencyMask
        [options]="{ allowNegative: true }"
      />
      <button
        type="button"
        *ngIf="form.get('fromAmount').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('fromAmount').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Amount to</mat-label>
      <input
        matInput
        formControlName="toAmount"
        type="text"
        placeholder="Amount to"
        currencyMask
        [options]="{ allowNegative: true }"
      />
      <button
        type="button"
        *ngIf="form.get('toAmount').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('toAmount').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select formControlName="status" placeholder="All">
        <mat-option>All</mat-option>
        <mat-option *ngFor="let option of bankTransationStatusOptions" [value]="option.value">
          {{ option.name | startCase }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Type</mat-label>
      <mat-select formControlName="type" placeholder="All">
        <mat-option>All</mat-option>
        <mat-option *ngFor="let option of bankTransationTypeOptions" [value]="option.value">
          {{ option.name | startCase }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Category</mat-label>
      <input matInput formControlName="category" type="text" placeholder="Category" />
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select matInput formControlName="active" placeholder="Status">
        <mat-option>All</mat-option>
        <mat-option value="true">Active</mat-option>
        <mat-option value="false">Inactive</mat-option>
      </mat-select>
    </mat-form-field>
  </ifc-base-filter-dialog>
</form>
